export default {
    individualCardStyle: {
        height: "209px",
        width: "230px",
    },

    cardHeader: {
        marginTop: "44px"
    },

    singleViewIndividualCardStyle: {
        height: "100px",
        width: "auto",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    
    singleViewCardHeader: {
        marginTop: 0,
        marginBottom: 0,  
    },
}